import { NavController, NavParams, App, ModalController, ViewController, ToastController, Content } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { AuthProvider } from '../../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../../providers/employeerh/employeerh';
import { GoalRhProvider } from '../../../../../providers/goals/goals';


@Component({
    selector: 'page-rh-interview-goals',
    templateUrl: 'rh-interview-goals.html',
})
export class RhInterviewGoalsPage implements OnInit {

    // DOMVar
    interview: any = null;
    employee : any = null
    // Form vars
    goals : any[] = []
    showNotice:boolean = true;


    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController,
        private goalRhProvider: GoalRhProvider
    ) {
        this.interview = this.navParams.get('interview').interview;
        this.employee = this.navParams.get('interview').employee;
    }

    ngOnInit() {
        this.goalRhProvider.getGoalsOfUser(this.interview.collaborator_id).subscribe((res) => {
            if(res.success){
                if(res.data == null){
                    this.goals.push({
                        title: null,
                        period: null,
                        percent_value: null
                    })
                }else{
                    this.goals = res.data
                    this.showNotice = false;
                }
            }
        })
    }


    addGoal(){
        this.goals.push({
            name: null,
            period: null,
            goal_date: new Date().toISOString(),
            percent: null,
        })
    }

    deleteGoal(index){
        this.goals.splice(index, 1)
    }

    setUnderstoodNotice(){
        this.showNotice = false;
    }

    // Submit :

    checkSubmitValues(goal){
        if(
            goal.title == null || 
            goal.period == null || 
            goal.percent_value == null
        ){
            return false;
        }else{
            return true;
        }
    }


    submit(){
        let totalPonderation = 0;
        let hasMissingValue = false;
        let hasInvalidPonderation = false;
        for(let goal of this.goals){
            totalPonderation += +goal.percent_value;
            if(!this.checkSubmitValues(goal)){
                hasMissingValue = true;
                let toast = this.toastCtrl.create({ message: "Erreur : certains champs sont incomplet", duration: 6000, position: 'top'});
                toast.present();
            }
        }
        if(totalPonderation !== 100){
            hasInvalidPonderation = true;
            let toast = this.toastCtrl.create({ message: "Erreur : le total de pondération doit être de 100% et non de " + totalPonderation + "%", duration: 6000, position: 'top'});
            toast.present();
        }

        if(!hasInvalidPonderation && !hasMissingValue){
            this.employeeRhProvider.saveUserInterviewGoals(this.interview.id, this.goals).subscribe((res) => {
                if(res.success){
                    let toast = this.toastCtrl.create({ message: "Les objectifs ont été sauvegarder, le collaborateur peut désormais remplir son entretien.", duration: 6000, position: 'top'});
                    toast.present();
                    this.dismiss()
                }
            })
        }



    }



    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-interview/rh-interview-goals/rh-interview-goals.ts